@if (store.alert(); as alert) {
    <vds-inline-alert
        class="w-full"
        [appearance]="$any(alert.appearance)"
        [dismissible]="alert.dismissable"
        [message]="alert.message"
        inline
        (dismiss)="store.dismissMessage(alert.id)"
    />
}
